import { MeRepository } from 'common/repositories/index';
import Cookie from 'common/services/util/-RFC.Cookie';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope'];

/**
 * @ngdoc directive
 * @name directives.controller.loginTypeController
 *
 * @description
 * Login type controller
 */
class LoginTypeController {

    /**
     * @param  {any} $scope
     */
    constructor($scope) {

        this.$scope = $scope;
        this.$scope.logintype = Cookie.get(CWCONFIG.cookie.loginType);
        this.$scope.userEmail = MeRepository.getMyEmail();

    }

}

/**
 * @ngdoc directive
 * @name directives.LoginTypeDirective
 *
 * @description
 * Login type directive
 */
class LoginTypeDirective {

    constructor() {

        this.template = require('./login-type.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push($scope =>
            new LoginTypeController($scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'LoginTypeCtrl';

    }

}

_directiveDependencies.push(() => new LoginTypeDirective());


angular.module('directives')
    .directive('loginType', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/security/login-type/login-type.js